NorthernShopper.fetch = {
  handleErrors: function (response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }
};

NorthernShopper.processCommunityUpdateEvent = function (e) {
  e.preventDefault(); // disable form from submitting.
  event.stopPropagation();

  console.log(`processCommunityUpdateEvent: ${e.target
    }`);

  // Let's see what's up and update session attributes
  let newCommunity = e
    .target
    .closest('form')
    .querySelector('select[name="community"]')
    .value;
  let freightType = e
    .target
    .closest('form')
    .querySelector('select[name="freight-type"]')
    .value;
  if (newCommunity !== null && newCommunity !== undefined && newCommunity.length > 0) {
    NorthernShopper.updateCommunity(newCommunity, freightType);
  }

  document.getElementById('community-selector').style.display = 'none';
};

NorthernShopper.updateCommunity = function (communityName, freightType = 'air', invalidateDefault = true) {

  console.log(`Updating community: '${communityName}' --> '${freightType}'`);

  // Send to Shopify to update the cart
  let queryParams = '';
  if (!invalidateDefault) {
    queryParams = '?ignore_refresh=true'
  }
  const payload = {
    attributes: {
      community: communityName,
      freight_type: freightType,
      sealift_landing_id: null
    }
  }

  if (freightType === 'sealift') { // We need to find the sealift_landing_id a.k.a the handle of the landing metaobject
    console.log("Searching to lifts");
    if (NorthernShopper.sealift) {
      for (const lift of NorthernShopper.sealift) {
        console.log(`Checking Lift ${lift.handle
          }`);
        if (lift.landings) {
          for (const landing of lift.landings) {
            console.log(`Checking Landing ${landing.handle
              }`);
            if (landing.community === communityName || landing.community_internal_name == communityName) {
              console.log(`Match Found`);
              payload.attributes['sealift_landing_id'] = landing.handle;
              break;
            }
          }
          if (payload.attributes.sealift_landing_id) {
            break;
          }
        }
      }
    }

    if (!payload.attributes.hasOwnProperty('sealift_landing_id')) {
      payload.attributes.freight_type = 'air';
    } else { // Let's remove any unsupported items
      for (const lineItem of NorthernShopper.cart) {
        if (!lineItem.sealift) {
          if (!payload.hasOwnProperty('updates')) {
            payload['updates'] = {};
          }
          payload.updates[lineItem.id] = 0;
        }
      }
    }
  }

  console.log(`Updating cart to:`, payload);

  fetch(window.Shopify.routes.root + 'cart/update.js' + queryParams, {
    method: 'POST',
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache',
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(payload)
  }).then(NorthernShopper.fetch.handleErrors).then(function (response) {

    // It was successful, let's save the cookie
    localStorage.setItem("northerShopperCommunity", communityName);
    if (invalidateDefault) {
      NorthernShopper.isDefault = false;
    }
    NorthernShopper.currentCommunity = communityName;

    if (window.location.href.indexOf('?') > 0) {
      window.location = window.location.href.split("?")[0];
    } else {
      window.location.reload();
    }
  });
};

let queryParams = new URLSearchParams(window.location.search);
if (queryParams.has('community')) {
  let community = queryParams.get('community');
  let freightType = queryParams.has('freight_type')
    ? queryParams.get('freight_type')
    : 'air';
  NorthernShopper.updateCommunity(community, freightType);
} else if (NorthernShopper.isDefault) {
  if (localStorage.getItem("northerShopperCommunity") !== null) { // We have a saved community, let's set it!
    // lets check if the community is valid
    const savedCommunity = localStorage.getItem("northerShopperCommunity");
    if (NorthernShopper.communities.hasOwnProperty(savedCommunity)) {
      NorthernShopper.updateCommunity(savedCommunity);
    } else {
      NorthernShopper.currentCommunity = NorthernShopper.defaultCommunity;
      NorthernShopper.updateCommunity(NorthernShopper.defaultCommunity, 'air', false);
    }
  } else {
    NorthernShopper.currentCommunity = NorthernShopper.defaultCommunity;
    NorthernShopper.updateCommunity(NorthernShopper.defaultCommunity, 'air', false);
  }
}

// Let's check if the current community is valid or not
let communitiesAvailable = Object.keys(NorthernShopper.communities);
if (communitiesAvailable.length > 0 && !communitiesAvailable.includes(NorthernShopper.currentCommunity)) { // We need to push a change in community
  NorthernShopper.updateCommunity(NorthernShopper.defaultCommunity, 'air', false);
}